export default {
    LOAD_AUDIO_FAILED: "Не удалось загрузить аудио"
};
